<template>
	<div v-if="wrapper.tabList.length" class="tabs">
		<div v-show="isExpand" class="tabs-expand">
			<div
				class="tab"
				:class="{ 'tab-active': wrapper.active == item.id }"
				:style="labelStyle(item)"
				v-for="item in wrapper.tabList"
				:key="item.id"
				@click="changeTab(item.id)"
			>
				{{ item.name }}
			</div>
			<div class="icon-arrow" @click="setExpand(false)">
				<m-svg-icon name="arrow_up"></m-svg-icon>
			</div>
		</div>
		<div v-show="!isExpand" class="tabs-collapse">
			<m-scroll
				class="tabs-scroll"
				:scrollX="true"
				:scrollY="false"
				eventPassthrough="vertical"
				@initScrollComplete="handleScrollComplete"
			>
				<div class="tabs-wrapper">
					<div
						class="tab"
						:class="{ 'tab-active': wrapper.active == item.id }"
						:style="labelStyle(item)"
						v-for="item in wrapper.tabList"
						:key="item.id"
						@click="changeTab(item.id)"
					>
						{{ item.name }}
					</div>
				</div>
			</m-scroll>
			<div v-if="canExpand" class="icon-arrow" @click="setExpand(true)">
				<m-svg-icon name="arrow_down"></m-svg-icon>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, watch } from 'vue';
import i18n, { EN } from '@/assets/js/i18n';

const props = defineProps({
	wrapper: { type: Object, required: true }
});

const emits = defineEmits(['tab-change']);
const changeTab = tabId => {
	emits('tab-change', tabId);
};

const isExpand = ref(false);
const canExpand = ref(false);
watch(
	() => props.wrapper.tabList?.length,
	() => {
		isExpand.value = false;
		canExpand.value = false;
	}
);

function handleScrollComplete(scroll) {
	const { wrapper } = scroll;
	canExpand.value = wrapper.scrollWidth > wrapper.clientWidth;
	if (!canExpand.value) {
		isExpand.value = false;
	}
}
function setExpand(expand) {
	if (!canExpand.value) return;
	isExpand.value = expand;
}

function labelStyle(row) {
	const needToSmallKeys = ['grossMargin', 'reserPs', 'tRevenue', 'operateProfit'];
	if (i18n.locale === EN && needToSmallKeys.includes(row.value)) {
		return { fontSize: '0.1rem' };
	}
	return {};
}
</script>

<style lang="less" scoped>
.tabs {
	overflow: hidden;
	.tabs-collapse {
		margin-bottom: 0.12rem;
		display: flex;
		align-items: center;

		.tabs-scroll {
			min-width: 0;
			overflow-x: auto;

			&::-webkit-scrollbar {
				display: none;
			}
		}
		.tabs-wrapper {
			position: relative;
			min-width: 100%;
			display: inline-flex;

			.tab + .tab {
				margin-left: 0.12rem;
			}
		}
		.icon-arrow {
			position: relative;
			height: 0.24rem;
			padding-left: 0.08rem;

			display: flex;
			align-items: center;

			&::before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				transform: translateX(-100%);
				width: 0.2rem;
				height: 100%;
				background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #fff 100%);
			}
		}
	}
	.tabs-expand {
		display: flex;
		flex-wrap: wrap;

		.tab {
			margin-right: 0.12rem;
			margin-bottom: 0.12rem;
		}

		.icon-arrow {
			height: 0.24rem;

			display: flex;
			align-items: center;
		}
	}
	.tab {
		flex-shrink: 0;
		height: 0.24rem;
		padding: 0 0.06rem;
		border-radius: 1px;
		background: #f6f7f8;

		color: #666;
		text-align: center;
		font-family: 'PingFang SC';
		font-size: 0.12rem;
		font-style: normal;
		font-weight: 400;
		line-height: 0.24rem;

		&-active {
			background: var(--ir-theme-color);
			color: #fff;
		}
	}
}
</style>
